import {
    Account,
    Auditable,
    Lockable,
    Person,
    QueryParams,
    SortParams,
    SurgeryStatus,
    SurgeryType,
    Tissue,
    TissueOffer,
} from "..";

export interface Surgery extends Auditable, Lockable {
    surgeonId?: number;
    surgeon?: Person;
    billingAccountId?: number;
    billingAccount?: Account;
    locationAccountId?: number;
    locationAccount?: Account;
    surgeryTypeId?: number;
    surgeryType?: SurgeryType;
    surgeryStatusId?: number;
    surgeryStatus?: SurgeryStatus;
    tissueId?: number;
    tissue?: Tissue;
    backupTissueId?: number;
    backupTissue?: Tissue;

    feeWaiverApprovedById?: number;
    feeWaiverApprovedOn?: string;
    feeWaiverApprovalDetail?: string;
    feeWaiverApprovalNotes?: string;

    surgeryDate?: string; // for UI input
    surgeryTime?: string; // for UI input
    surgeryTimeZone?: string;
    scheduledOnUtc?: string;

    poNumber: string;
    punch: string;
    surgeonPreferences: string;

    pendingCreateApproval: boolean;
    pendingRescheduleApproval: boolean;
    pendingCancelApproval: boolean;

    recipientFirstName: string;
    recipientMiddleName: string;
    recipientLastName: string;
    recipientSuffix: string;
    recipientAddress: string;
    recipientCity: string;
    recipientState: string;
    recipientZip: string;
    recipientIsInsured: string;
    recipientUid: string;
    recipientSex: string;
    recipientAge?: number;
    recipientBirthDate: string;
    recipientRace: string;

    feeWaiverType: string;
    feeWaiverDetail: string;
    preOpDiagnosis: string;
    preOpDiagnosisDetail: string;
    hasBackupTissue: boolean;
    otherProcedure: string;
    procedureTypeId: number;

    invoiceIds?: number[];
    tissueOffers?: TissueOffer[];
}

export interface SurgeryFeeWaiverApprovalRequest {
    surgeryId: number;
    pin?: number;
}

export const DefaultSurgeryQueryParams: QueryParams = {};

export const DefaultSurgerySortParams: SortParams = {
    orderBy: "scheduledOnUtc",
    orderDesc: "false",
};
